export const getDragBounds = (height = 0, width = 0, zoom = 1) => {
  const originalWidth = width / zoom;
  const right = 0.5 * (width - originalWidth);
  const left = -1 * right;

  const originalHeight = height / zoom;
  const bottom = 0.5 * (height - originalHeight);
  const top = -1 * bottom;
  return { bottom, left, right, top };
};
